import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaHome, FaSearch, FaBlog, FaInfoCircle, FaPhoneAlt, FaFacebook } from 'react-icons/fa';
import { FaXTwitter, FaTelegram, FaInstagram, FaWhatsapp } from 'react-icons/fa6';
import Logo from '../common/Logo';
import { TELEGRAM_CHANNEL_URL } from '../../config/social';
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/people/Jobs-Opportuniti/pfbid0vDPT2QsHfzUS26Q94JgptsuioacViMEiDH3JKFBVgiv27SxnjSsthk7r63EZNXw9l/',
      icon: <FaFacebook />
    },
    { 
      name: 'Instagram', 
      url: 'https://www.instagram.com/jobsopportunity.in/?igsh=NDI4N2p3ZW1yM24%3D#', 
      icon: <FaInstagram /> 
    },
    { 
      name: 'X', 
      url: 'https://x.com/Jobsopport61352?t=B5pSngdXa5VdKvp7HvXDtQ&s=08', 
      icon: <FaXTwitter /> 
    },
    { 
      name: 'Telegram', 
      url: TELEGRAM_CHANNEL_URL, 
      icon: <FaTelegram /> 
    },
    { 
      name: 'WhatsApp', 
      url: 'https://wa.me/919380867233', 
      icon: <FaWhatsapp /> 
    }
  ];

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const menuItems = [
    { path: '/', icon: <FaHome />, label: 'Home' },
    { path: '/search', icon: <FaSearch />, label: 'Search Jobs' },
    { path: '/blogs', icon: <FaBlog />, label: 'Blogs' },
    { path: '/about', icon: <FaInfoCircle />, label: 'About Us' },
    { path: '/contact', icon: <FaPhoneAlt />, label: 'Contact Us' },
  ];

  return (
    <header className="header">
      <nav className="nav container">
        <Logo />
        
        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <div className="hamburger-box">
            <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
          </div>
        </button>

        {/* Desktop Navigation */}
        <div className="desktop-nav">
          {menuItems.map((item) => (
            <Link 
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        {/* Social Media Links - Replace Login Button */}
        <div className="header-social-links">
          {socialLinks.map(link => (
            <a 
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="header-social-link"
              title={link.name}
            >
              {link.icon}
            </a>
          ))}
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div 
              className="mobile-nav-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsMenuOpen(false)}
            >
              <motion.div 
                className="mobile-nav"
                initial={{ x: '100%' }}
                animate={{ x: 0 }}
                exit={{ x: '100%' }}
                transition={{ type: 'tween', duration: 0.3 }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="mobile-nav-header">
                  <Logo isStatic={true} />
                  <button 
                    className="close-btn"
                    onClick={() => setIsMenuOpen(false)}
                    aria-label="Close menu"
                  >
                    ×
                  </button>
                </div>

                <div className="mobile-nav-content">
                  {menuItems.map((item, index) => (
                    <motion.div
                      key={item.path}
                      initial={{ x: 50, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ delay: index * 0.1 }}
                    >
                      <Link 
                        to={item.path}
                        className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
                      >
                        {item.icon}
                        <span>{item.label}</span>
                      </Link>
                    </motion.div>
                  ))}
                </div>

                {/* Replace mobile login with social links */}
                <motion.div 
                  className="mobile-nav-footer"
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.3 }}
                >
                  <div className="mobile-social-links">
                    {socialLinks.map(link => (
                      <a 
                        key={link.name}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mobile-social-link"
                      >
                        {link.icon}
                        <span>{link.name}</span>
                      </a>
                    ))}
                  </div>
                </motion.div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </header>
  );
}

export default Header; 